import { BadgeFilters } from './badge-filters';
import { ratios, metrics } from '../search-filters-data';
import SectorFilters from './sector-filters';
import CompanySizeFilters, { CompanySizeFilterBy } from './company-size-filters';

export const RatioFilters = BadgeFilters({ title: 'Ratios', type: 'ratio', data: ratios });
export const MetricFilters = BadgeFilters({ title: 'Metrics', type: 'metric', data: metrics });
export { SectorFilters, CompanySizeFilters, CompanySizeFilterBy };
